import React from 'react';
import { useTranslation } from '../App';

const Marquee = () => {
  const t = useTranslation();
  return (
    <section className="a-section">
      <div className="a-section-marquee-box">
        <h2 className="marquee-text">{t.marquee.text}</h2>
      </div>
    </section>
  );
};

export default Marquee;